module.exports = __webpack_public_path__ + "static/Bundle2_VinylAll-5c987a076960f55e62ff82d700578749.png";